// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretsOutHorizontalWithLine(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretsOutHorizontalWithLine" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 4.5L7.5 19.5L1.5 11.9996L7.5 4.5Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 19.5L16.5 4.5L22.5 12.0004L16.5 19.5Z", fill: "currentColor" }),
            React.createElement("rect", { x: "10.5", y: "19.5", width: "15", height: "3", transform: "rotate(-90 10.5 19.5)", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretsOutHorizontalWithLine.js.map